import React, { useState } from 'react';
interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}
interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
}
export function Tabs({
  tabs,
  defaultTab
}: TabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0].id);
  return <div className="flex flex-col h-full" data-id="element-484">
      <div className="flex border-b border-border mb-6" data-id="element-485">
        {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-6 py-3 font-mono text-xs uppercase tracking-widest transition-colors border-b-2 ${activeTab === tab.id ? 'border-primary text-primary bg-primary/5' : 'border-transparent text-muted-foreground hover:text-foreground hover:bg-secondary/50'}`} data-id="element-486">
            {tab.label}
          </button>)}
      </div>
      <div className="flex-1 overflow-y-auto" data-id="element-487">
        {tabs.find(t => t.id === activeTab)?.content}
      </div>
    </div>;
}